
import EDChip from '../EDChip';
import EDBox from '../../EDBox/EDBox';
import EDIcon from '../../Icon/EDIcon';

interface IProps {
  items: ILockedItem[];
}

export interface ILockedItem {
  name: string;
  nameLabel: string;
}

/**
 * Lista av chips med lås
 */
const LockedChipList: React.FC<React.PropsWithChildren<IProps>> = props => {
  return (
    <EDBox
      sx={{
        display: 'block',
      }}
    >
      {props.items.map((x, index) => (
        <EDBox
          key={index}
          sx={{
            marginTop: theme => theme.spacing(1),
            marginBottom: theme => theme.spacing(1),
          }}
        >
          <EDChip
            lockedChip
            label={x.name || ''}
            fullWidth
            icon={<EDIcon iconType="lock" />}
          />
        </EDBox>
      ))}
    </EDBox>
  );
};

export default LockedChipList;
